import React from 'react';
import { useNavigate } from "react-router-dom";

const Questions = () => {
  const navigate = useNavigate();

  return (
    <div className="questions-container">
      <div className="questions-header">
        <h1>Staff Management</h1>
        <p>Manage staff members and their roles</p>
      </div>

      <div className="questions-grid">
        {/* Staff Card */}
        <div className="questions-card" onClick={() => navigate("/staff-details")}>
          <div className="card-icon-wrapper bg-blue-100">
            <i className="ph-duotone ph-chalkboard-simple"></i>
          </div>
          <h3>Staff</h3>
          <p>View and manage staff members</p>
          <span className="card-action">Manage →</span>
        </div>

        {/* Role Card */}
        <div className="questions-card" onClick={() => navigate("/role")}>
          <div className="card-icon-wrapper bg-purple-100">
            <i className="ph-duotone ph-user"></i>
          </div>
          <h3>Role</h3>
          <p>Configure staff roles and permissions</p>
          <span className="card-action">Configure →</span>
        </div>
      </div>

      <style>
        {`
          .questions-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }
          
          .questions-header {
            max-width: 1200px;
            margin: 0 auto 2.5rem;
            padding: 0 0.75rem;
          }
          
          .questions-header h1 {
            font-size: 2rem;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          .questions-header p {
            font-size: 1rem;
            color: #718096;
          }
          
          .questions-grid {
            max-width: 1200px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 1.25rem;
            padding: 0 0.75rem;
          }
          
          .questions-card {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid #e2e8f0;
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 180px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }
          
          .questions-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #667eea, #764ba2);
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          .questions-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
            border-color: #cbd5e0;
          }
          
          .questions-card:hover::before {
            opacity: 1;
          }
          
          .questions-card:hover .card-action {
            opacity: 1;
            transform: translateX(0);
          }
          
          .card-icon-wrapper {
            width: 60px;
            height: 60px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1rem;
            transition: all 0.3s;
          }
          
          .questions-card:hover .card-icon-wrapper {
            transform: scale(1.08) rotate(3deg);
          }
          
          .card-icon-wrapper i {
            font-size: 1.75rem;
          }
          
          /* Background color classes */
          .bg-blue-100 { background-color: #dbeafe; color: #2563eb; }
          .bg-purple-100 { background-color: #f3e8ff; color: #7c3aed; }
          
          .questions-card h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 0.375rem;
          }
          
          .questions-card p {
            font-size: 0.8125rem;
            color: #718096;
            margin-bottom: 0.75rem;
            flex-grow: 1;
            line-height: 1.4;
          }
          
          .card-action {
            font-size: 0.8125rem;
            font-weight: 500;
            color: #4f46e5;
            opacity: 0;
            transform: translateX(-8px);
            transition: all 0.3s;
          }
          
          /* Responsive design */
          @media (max-width: 768px) {
            .questions-container {
              padding: 1rem;
            }
            
            .questions-header h1 {
              font-size: 1.75rem;
            }
            
            .questions-header p {
              font-size: 0.9375rem;
            }
            
            .questions-grid {
              grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
              gap: 1rem;
              max-width: 400px;
            }
            
            .questions-card {
              padding: 1.25rem;
              min-height: 160px;
            }
            
            .card-icon-wrapper {
              width: 56px;
              height: 56px;
              border-radius: 14px;
            }
            
            .card-icon-wrapper i {
              font-size: 1.5rem;
            }
          }
          
          @media (max-width: 480px) {
            .questions-grid {
              grid-template-columns: 1fr;
              max-width: 280px;
            }
            
            .questions-card {
              min-height: 140px;
              padding: 1rem;
            }
          }
          
          @media (min-width: 768px) and (max-width: 1024px) {
            .questions-grid {
              grid-template-columns: repeat(3, 1fr);
            
            }
          }
          
          @media (min-width: 1024px) {
            .questions-grid {
              grid-template-columns: repeat(4, 1fr);
            
            }
          }
        `}
      </style>
    </div>
  );
};

export default Questions;